import React from 'react'

import { Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'

import { FieldGroup } from './FieldGroup'

export const ForgotPasswordForm = ({ onSubmit, onChange, validateForm, username, children }) => (
  <div className="AuthContainerForm">
    <h1>Provide the email address you used to set up your account</h1>

    {children}

    <form onSubmit={onSubmit} className="col mt-x2 pt">
      <FieldGroup id="username" label="Email Address" value={username} onChange={onChange} autoFocus className="field-group_input" />

      <Button id="forgot-password-button" className="btn btn-default" type="submit" disabled={!validateForm()}>
        Submit
      </Button>
      <Link to="/login" className="btn btn-link"> Cancel</Link>
    </form>

  </div>
)
